import { useState } from "react";
import { homeService } from "@miplatform/api";
import { useComponentState, useDebounce } from "@miplatform/hooks";
import { buildSearchQuery } from "@miplatform/utils";

export function useManageCitiesViewModel() {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const [cities, setCities] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);

  const getCities = ({ search = "", top, skip } = {}) => {
    const searchQuery = buildSearchQuery(search, [
      "cityName",
      "regionCode",
      "countyName",
    ]);
    return stateManager.run(async () =>
      homeService.cities.getAll({
        sort: ["regionCode", "cityName"],
        filters: searchQuery,
        top,
        skip,
      })
    );
  };

  return {
    cities,
    search,
    debouncedSearch,
    isLoading,
    setSearch,
    setCities,
    getCities,
  };
}
